const copaOtono2026 = [
	{
		name: "FINAL",
		location: "Aluche",
		date: "2026-11-29T09:30:00",
		// score: "",
		// link: "",
		// shortId: "",
	},
	{
		name: "SEMIFINAL",
		location: "Aluche",
		date: "2026-11-22T09:30:00",
		// score: "",
		// link: "",
		// shortId: "",
	},
	{
		name: "Jornada de recuperación",
		location: "Aluche",
		date: "2026-11-15T09:30:00",
		tornament: "Liga de otoño",
		// score: "",
		// link: "",
		// shortId: "",
	},
	{
		vs: "Águilas",
		location: "Aluche",
		date: "2026-11-08T09:30:00",
		tornament: "Liga de otoño",
		// score: "",
		// link: "",
		// shortId: "",
	},
	{
		vs: "Gladiadoras",
		location: "Aluche",
		date: "2026-10-25T16:50:00",
		tornament: "Liga de otoño",
		// score: "",
		// link: "",
		// shortId: "",
	},
	{
		vs: "Vikingas",
		location: "Aluche",
		date: "2026-10-25T15:00:00",
		tornament: "Liga de otoño",
		// score: "",
		// link: "",
		// shortId: "",
	},
	{
		vs: "Goodies",
		location: "Aluche",
		date: "2026-10-18T10:40:00",
		tornament: "Liga de otoño",
		score: "7-1",
		link: "https://youtu.be/Fn3tbSIHJkk?si=D1bDmf29ls5xjnal",
		shortId: "YwSNr7kIMJE",
	},
	{
		vs: "Gladiadoras",
		location: "Aluche",
		date: "2026-10-18T09:00:00",
		tornament: "Liga de otoño",
		score: "7-3",
		link: "https://youtu.be/OXoTqzV6tbE?si=5dsQ0bpUNeP3m7AB",
		shortId: "55F9CShx_cw",
	},
	{
		vs: "Las Panas",
		location: "Aluche",
		date: "2026-10-04T16:50:00",
		tornament: "Liga de otoño",
		score: "4 - 9",
		link: "https://youtu.be/qrECgJvrFRQ?si=t-FobVlwExRp7pFN",
		shortId: "dqQhdOsHRGE",
	},
	{
		vs: "Águilas",
		location: "Aluche",
		date: "2026-10-04T15:00:00",
		tornament: "Liga de otoño",
		score: "5 - 5",
		link: "https://youtu.be/JZ-pFGazySo?si=A6BAoaOLsFrwHwsc",
		shortId: "HfgfuG5YYBE",
	},
];

const copaPrimavera2026 = [
	// {
	// 	name: "FINAL",
	// 	location: "Aluche",
	// 	date: "2026-06-14T10:30:00",
	// 	image: "pictures/photo-56.webp",
	// 	tornament: "Round Robin - Copa Primavera",
	// },
	{
		vs: "Goodies",
		location: "Aluche",
		date: "2026-06-07T16:50:00",
		tornament: "Round Robin - Copa Primavera",
	},
	{
		vs: "Panteras",
		location: "Aluche",
		date: "2026-06-07T15:00:00",
		tornament: "Round Robin - Copa Primavera",
	},
	{
		vs: "Huracanes",
		location: "Aluche",
		date: "2026-05-31T13:10:00",
		tornament: "Round Robin - Copa Primavera",
		score: "3 - 2",
		link: "https://youtu.be/I8yDwqPiAn4?si=TbJWQFOWQfX-VIDN",
		shortId: "e7HF3VYufkY",
	},
	{
		vs: "Vikingas",
		location: "Aluche",
		date: "2026-05-31T09:30:00",
		tornament: "Round Robin - Copa Primavera",
		score: "1 - 8",
		link: "https://youtu.be/g72Ahi9CLB4?si=ssFDQ71OyWb_kNOY",
		shortId: "9tvxL4v4r_M",
	},
	{
		vs: "Murallas",
		location: "Aluche",
		date: "2026-05-24T13:10:00",
		score: "15 - 3",
		link: "https://youtu.be/CBsNqUMx3BQ?is=X_bKf4JWgNr8SD_z",
		shortId: "jb0AR-nygOU",
	},
	{
		vs: "Panas",
		location: "Aluche",
		date: "2026-05-24T09:30:00",
		score: "7 - 3",
		link: "https://youtube.com/shorts/_C0pldZWcaI?is=j76itCuZrTFcJqTQ",
		shortId: "_C0pldZWcaI",
	},
	{
		vs: "Panas",
		location: "Jarama",
		date: "2026-04-26T16:50:00",
		score: "7 - 4",
		link: "https://youtu.be/6qSaeJ-N6M8?si=MXnQ8yzjV2kxdx_e",
		shortId: "7-zm00w6vKg?si=JdwJEf3pO7OIfPrc",
	},
	{
		vs: "Murallas",
		location: "Jarama",
		date: "2026-04-26T15:00:00",
		score: "9 - 1",
		link: "https://youtu.be/WPI_z2CaNDQ?si=xkjB-G4MTKNb-xcA",
		shortId: "5kqOeeBxM38?si=JJgak_1S9We9t_Pt",
	},
	{
		vs: "Goodies",
		location: "Aluche",
		date: "2026-04-19T09:00:00",
		score: "6 - 6",
		link: "https://youtu.be/EOuEIE2cHrg?si=71ZBAN-JseiGBgjc",
		shortId: "_boLrgDgHb4?si=f6syYCNXJPkvaxfC",
	},
	{
		vs: "Vikingas",
		location: "Aluche",
		date: "2026-04-19T09:00:00",
		score: "5 - 5",
		link: "https://youtu.be/0NUq2J6pPa4?si=4dczHrCLFCvlM4tH",
		image: "pictures/photo-31.webp",
		shortId: "vw8NNEI0T0o?si=2FivJu7OYPBsZ3QL",
	},
];
export const events = [...copaOtono2026, ...copaPrimavera2026].map((c) => ({ ...c, tornament: c.tornament || "Copa Primavera" }));
